import React from 'react';
import TextField from '@material-ui/core/TextField';



class AbacusTextFieldBox extends React.Component {

  handleChange = value => event => {
    if(this.props.onChange !== undefined){
      this.props.onChange(event);
    }
  };

  onBlur = value => event => {
    if(this.props.onBlur !== undefined){
      this.props.onBlur(event);
    }
  };

  keyDown = value => e => {

    if(this.props.IsNumeric)
    {
      // Num Pad
      var keyCode = e.keyCode || e.which;
      if (keyCode >= 96 && keyCode <= 105) {
          // Numpad keys
          keyCode -= 48;
      }
      var number = String.fromCharCode(keyCode)

      if ((number.match(/[^\d]/g)) && !(e.ctrlKey === true && (e.which === 67 || e.which === 86)) && e.which !== 17 && e.which !== 9 && e.which !== 190 && e.which !== 188 && e.which !== 8 && e.which !== 36 && e.which !== 35 && e.which !== 37 && e.which !== 39 && e.which !== 46 && e.which !== 110) {
        e.preventDefault(); // Let's stop this event.
        e.stopPropagation(); // Really this time.
      }
    }
  };

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.Name === this.props.Name && nextProps.value === this.props.value && nextProps.error === this.props.error && nextProps.errorText === this.props.errorText && nextProps.helperText === this.props.helperText && nextProps.disabled === this.props.disabled){
      return false;
    }
    return true;
  }
  
    render() {
      return (
        <TextField
          name={this.props.name === undefined ? "" : this.props.name}
          required = {this.props.required}
          style={this.props.style}
          disabled={this.props.disabled}
          label={this.props.Name}
          error={this.props.error}
          helperText={this.props.error?this.props.errorText:this.props.helperText}
          //className={classes.textField}
          autoComplete={this.props.autoComplete === undefined ? "off" : this.props.autoComplete}
          value={this.props.value}
          onChange={this.handleChange('value').bind(this)}
          onBlur={this.onBlur().bind(this)}
          onKeyDown={this.keyDown()}
          margin="normal"
          variant="outlined"   
          multiline 
          rowsMax="4"     
          InputProps={{ style:  this.props.inputClass }}
        />
      );
    }
  }

  export default AbacusTextFieldBox;